import * as React from 'react'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

interface Props {
  title: string;
  description: React.ReactNode;
  icon: React.ReactNode;
  tabletIcon: React.ReactNode;
}

function CharterBundleLandingPageUspItem(props: Props) {
  return <Group direction="vertical" gap={12} horizontalAlign="start">
    <CSSBreakpoint max="tablet">
      {props.icon}
    </CSSBreakpoint>
    <CSSBreakpoint min="desktop">
      {props.tabletIcon}
    </CSSBreakpoint>
    <VerticalSpacer gap={8}>
      <CSSBreakpoint max="tablet">
        <Heading variant="heading5">
          {props.title}
        </Heading>
      </CSSBreakpoint>
      <CSSBreakpoint min="desktop">
        <Heading variant="heading5" wrap="no-wrap">
          {props.title}
        </Heading>
      </CSSBreakpoint>
      <BodyText variant="medium">
        {props.description}
      </BodyText>
    </VerticalSpacer>
  </Group>
}

export default CharterBundleLandingPageUspItem
